<template>
  <div>

    <div v-if="curImages" class="gallery">
      <imgHolder v-for="img in curImages" v-bind:key='img' :image="img"/>
    </div>

    <div v-if="totalPages" class="pagination">
      <a v-bind:href="pageNum - 1"><h3 v-if="pageNum !== 1">{{prev}}</h3></a>
      <a v-bind:href="index + 1" v-for="(num, index) in totalPages" :key="index + 1" :class="{current: pageNum == (index + 1)}"><h3>{{index + 1}}</h3></a>
      <a v-bind:href="pageNum + 1"><h3 v-if="pageNum !== (totalPages - 1)">{{next}}</h3></a>
    </div>

  </div>
</template>

<script>
  import imgHolder from "./image";
  import { database } from "../firebase.js";

  export default {
    name: 'Gallery',
    data() {
      return {
        images: [],
        curImages: [],
        pageNum: 1,
        perPage: 26,
        totalPages: 0,
        prev: '<',
        next: '>'
      };
    },
    components: {
      imgHolder
    },
    watch:{
      'pageNum'() {
        this.getPaginatedImages();
      }
    },
    mounted() {
      if (this.$route.params.page){
        this.pageNum = this.$route.params.page;
      }
      this.getAllImages();
    },
    methods: {
      async getAllImages() {
        let self = this;

        database.ref('GIFURLs').on('value', function(snapshot) {
          for (let key in snapshot.val()) {

            if (!self.images.includes(snapshot.val()[key].url)){
              self.images.unshift(snapshot.val()[key].url);
            }
          }

          self.getPaginatedImages();
          self.totalPages = Math.ceil(self.images.length / self.perPage);
        })
      },
      getPaginatedImages() {
        let start = (this.pageNum - 1) * this.perPage;
        if (this.pageNum !== 1) start++;
        let end = start + this.perPage;
        
        this.curImages = this.images.slice(start, end);
      },
    }
  }
</script>